<template>
<!--    快捷创建模板导入-->
    <el-dialog width="55%" title="模板导入"
               :visible.sync="isShow"
               append-to-body
               :close-on-click-modal="false">
        <el-tabs v-model="activeName" v-if="mode === 'all'">
            <el-tab-pane label="上传试卷" name="upload" style="width: 70%; margin: 0 auto">
                <div style="margin: 30px 0; display: flex">
                    <div style="min-width: 100px">下载模板</div>
                    <a
                        :href="$store.state.protocol + '//fmh.cqvip.com/download/ed149d669bc0454fb39fcffe91b198ed.docx'"
                        download="试卷模板"
                        target="_blank"
                        style="text-decoration: none;color:#3296fa;"><i
                        class="el-icon-download"
                        style="margin:0 5px"></i>下载试卷导入word模板</a>
                </div>
                <div style="margin: 30px 0; display: flex; align-items: center">
                    <div style="min-width: 100px">选择文件</div>
                    <el-input readonly :value="uploadFile.name" placeholder="请上传文件" size="small"/>
                    <el-button type="primary" @click="importPaper" icon="el-icon-upload" size="small">上传</el-button>
                </div>
                <div style="margin: 30px 0; display: flex">
                    <div style="min-width: 100px">导入说明</div>
                    <div>word批量导入试题功能支持“单选题、多选题、判断题、填空题、问答题”五类题型的导入</div>
                </div>
                <div class="xy-center">
                    <el-button type="primary" size="small"
                               :disabled="!uploadFile.name"
                               :loading="isUploading"
                               @click="upload">保存试卷</el-button>
                    <el-button type="default" size="small" :loading="isUploading" @click="close">取消</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="智能录入" name="input">
                <div class="e-condition xy-between flex-wrap" id="paper-import-driver-add-paper-step-one">
                    <div class="xy-center jf-start item">
                        <div class="name">试卷名称</div>
                        <el-input
                            v-model="paperInfo.name"
                            placeholder="请填写试卷名称"
                        ></el-input>
                    </div>
                    <div class="xy-center jf-start item">
                        <div class="name">所属分类</div>
                        <medical-class-selector
                            ref="medicalClass"
                            v-model="paperInfo.type"
                            :add-all="false"
                            @categories-load="updateOrganClass"
                        ></medical-class-selector>
                    </div>
                    <div class="xy-center jf-start item">
                        <div class="name">用途</div>

                        <el-select v-model="paperInfo.useFor" placeholder="请选择">
                            <el-option
                                v-for="item in useForData"
                                :key="item.value"
                                :value="item.value"
                                :label="item.name"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="xy-center jf-start item">
                        <div class="name">总分</div>
                        <el-input
                            v-model.number="paperInfo.totalScore"
                            :disabled="true"
                            type="number"
                            placeholder="总分自动计算"
                        ></el-input>
                    </div>
                    <div class="xy-center jf-start item">
                        <div class="name">及格分</div>
                        <el-input
                            v-model.number="paperInfo.passScore"
                            type="number"
                            @input="
                        (vl) => {
                            if (vl > paperInfo.totalScore) {
                                $message.warning('超过了试卷总分');
                            }
                        }
                    "
                        ></el-input>
                    </div>
                    <div class="xy-center jf-start item">
                        <div class="name">权限</div>
                        <el-select v-model="paperInfo.privilege" placeholder="请选择">
                            <el-option :value="1" label="机构公开"></el-option>
                            <el-option :value="2" label="平台公开"></el-option>
                        </el-select>
                    </div>
                </div>
                <auto-import :paper-info="paperInfo"
                             @sourceChange="onSourceChange"
                             style="margin: 30px 0" ref="autoImport"/>
                <div class="xy-center">
                    <el-button type="primary" size="small"
                               :loading="isUploading"
                               @click="goSave()">保存试卷</el-button>
                    <el-button type="default" size="small" :loading="isUploading" @click="close">取消</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
         <template v-else>
             <div style="margin: 30px 0; display: flex">
                 <div style="min-width: 100px">下载模板</div>
                 <a
                     :href="$store.state.protocol + '//fmh.cqvip.com/download/ed149d669bc0454fb39fcffe91b198ed.docx'"
                     download="试卷模板"
                     target="_blank"
                     style="text-decoration: none;color:#3296fa;"><i
                     class="el-icon-download"
                     style="margin:0 5px"></i>下载试卷导入word模板</a>
             </div>
             <div style="margin: 30px 0; display: flex; align-items: center">
                 <div style="min-width: 100px">选择文件</div>
                 <el-input readonly :value="uploadFile.name" placeholder="请上传文件" size="small"/>
                 <el-button type="primary" @click="importPaper" icon="el-icon-upload" size="small">上传</el-button>
             </div>
             <div style="margin: 30px 0; display: flex">
                 <div style="min-width: 100px">导入说明</div>
                 <div>word批量导入试题功能支持“单选题、多选题、判断题、填空题、问答题”五类题型的导入</div>
             </div>
             <div class="xy-center">
                 <el-button type="primary" size="small"
                            :disabled="!uploadFile.name"
                            :loading="isUploading"
                            @click.stop="upload">保存试卷</el-button>
                 <el-button type="default" size="small" :loading="isUploading" @click="close">取消</el-button>
             </div>
         </template>
    </el-dialog>
</template>

<script>
import { uploadOfInput, uuid } from "@/utils";
import { createPaper, importPaperFromWord, uploadFile } from "@/api/manage";
import { CommonPage } from "@/mixins/commonData";
import AutoImport from "@/views/manage/exam/cpns/autoImport";
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import { SubjectType } from "@/kernel";
export default {
    name: "quick-template-paper",
    components: { AutoImport, MedicalClassSelector },
    mixins: [CommonPage],
    props: {
        mode: {
            type: String,
            default: 'all' // all or paperImport
        }
    },
    data () {
        return {
            isShow: false,
            activeName: "upload",
            uploadFile: {},
            organClass: [],
            isUploading: false,
            paperInfo: {
                name: "",
                type: 0,
                useFor: 1,
                totalScore: null,
                passScore: null,
                privilege: 1,
                subjectNum: 0
            },
        }
    },
    methods: {
        open () {
            this.isShow = true
        },
        close () {
            if (this.$refs.medicalClass) {
                this.$refs.medicalClass.selected = []
            }
            if (this.$refs.autoImport) {
                this.$refs.autoImport.clear()
            }
            this.paperInfo = {
                name: "",
                type: 0,
                useFor: 1,
                totalScore: null,
                passScore: null,
                privilege: 1,
                subjectNum: 0
            }
            this.isShow = false
        },
        upload () {
            this.isUploading = true
            uploadFile({ file: this.uploadFile }).then(url => {
                importPaperFromWord(url).then(paperId => {
                    this.isUploading = false
                    if (this.mode === 'all') {
                        this.close()
                        this.$router.push({
                            path: "/manage/paperImport",
                            query: {
                                paperId: paperId,
                                url
                            }
                        }).then(() => {
                            this.$message.success("导入成功")
                        })
                    } else {
                        this.uploadFile = {}
                        this.$emit('importSuccess', {
                            paperId,
                            url
                        })
                        this.$message.success("导入成功")
                        this.close()
                        console.log('close')
                    }
                }).catch(e => {
                    this.isUploading = false
                })
            }).catch(e => {
                this.isUploading = false
            })
        },
        importPaper() {
            uploadOfInput((file) => {
                if (!file) return
                this.uploadFile = file
            }, () => {
                this.$message.error("选择文件失败")
            }, ".doc,.docx")
        },
        updateOrganClass(list) {
            this.organClass.length = 0
            this.organClass.push(...list)
        },
        checkError(typeList) {
            let message;
            for (let i = 0; i < typeList.length; i++) {
                const item = typeList[i];
                if (!item.Content) {
                    message = "请输入模块名称";
                    break;
                }
                let hasQues = item.SubjectList && item.SubjectList.length > 0
                if (!hasQues) {
                    message = "请添加试题";
                    break;
                }
                if (hasQues) {
                    const isFill = item.SubjectList.every((q) => q.Score);
                    if (!isFill) message = "请输入试题分数";
                }
            }
            return message;
        },
        onSourceChange () {
            const typeList = this.$refs.autoImport.queData
            const totalSource = typeList.reduce((preVal, curVal) => {
                return preVal + (curVal.Score || 0)
            }, 0)
            this.paperInfo.totalScore = totalSource
        },
        goSave(event = () => {}) {
            const typeList = this.$refs.autoImport.queData
            if (typeList.length === 0) return this.$message.warning("请输入题干")
            if (!this.paperInfo.name) return this.$message.warning("请输入试卷名称")
            if (this.paperInfo.type == null || this.paperInfo.type === "" || this.paperInfo.type === 0) return this.$message.warning("请选择所属分类")
            if (this.paperInfo.passScore === '' || this.paperInfo.passScore == null) return this.$message.warning("请输入及格分")
            typeList.forEach((q, index) => {
                if (q.ClassId == null || q.ClassId === 0) {
                    q.ClassId = this.paperInfo.type
                }
                if (q.UseType == null || q.UseType === 0) {
                    q.UseType = this.paperInfo.useFor
                }
                if (q.SubjectType === 3 && Array.isArray(q.Answer)) {
                    q.Answer = q.Answer.join("、")
                }
                if (q.SubjectType === SubjectType.multiple && Array.isArray(q.Answer)) {
                    q.Answer = q.Answer.join("、")
                }
            });
            console.log(" this.typeList:", typeList);
            const type = {
                1: "选择题",
                2: "多选题",
                3: "填空题",
                4: "判断题",
                5: "简答题"
            }
            const quesList = [{
                SubjectList: typeList,
                Content: type[typeList[0].SubjectType],
                RankNum: 1,
                SubScore: undefined,
                SubjectNum: typeList.length,
                TotalScore: this.paperInfo.totalScore,
                uuid: uuid()
            }]
            let message = this.checkError(quesList);
            console.log("message:", message);
            if (message) {
                this.$message.warning(message);
                return;
            }
            this.isUploading = true
            createPaper({
                examPaperModel: JSON.stringify({
                    ExamName: this.paperInfo.name,
                    ClassId: this.paperInfo.type,
                    ExamUse: this.paperInfo.useFor,
                    Authority: this.paperInfo.privilege,
                    PassScore: this.paperInfo.passScore,
                    TotalScore: this.paperInfo.totalScore,
                    SubjectNum: typeList.length,
                    SubjectTypeList: quesList
                })
            }).then((res) => {
                this.$message.success("创建成功");
                event(res);
                this.isUploading = false
                this.close()
                this.$emit("confirm", res)
            }).catch((e) => {
                // console.log("e:", e);
                // this.$message.warning(e.msg);
                this.isUploading = false
            });
        },
    }
}
</script>
<style lang="less" scoped>
.e-condition ::v-deep {
    padding: 0 30px;

    .item {
        margin-top: 30px;
        margin-right: 10px;

        .name {
            white-space: nowrap;
            width: 4em;
            font-size: 16px;
            text-align: right;
            padding-right: 8px;
        }
    }

    .el-input {
        width: 210px;
        height: 34px;

        input {
            height: 34px;

            ::placeholder {
                font-size: 16px;
            }
        }
    }
}
</style>
